
export const DefaultTopCharts = [
    {id: "5fbcc9963c98420004ccf7de", count: 1},
    {id: "6329aa5e4e34610190c53a6c", count: 1},
    {id: "6329d29abf3704140feba2b6", count: 1},
    {id: "60040ed09a59df627ea3d7d8", count: 1},
];
